import { useContext } from 'react';
import { BrandContext } from '../contextProviders';

export const useBrand: () => string | undefined = () => {
    return useContext(BrandContext);
};
